import moment from 'moment-timezone'

export const isWithinDateRange = ({
  startDate,
  endDate,
  timeZone,
  date,
}: {
  startDate?: string | Date | null
  endDate?: string | Date | null
  timeZone: string
  date?: string | number | Date | null
}) => {
  if (!startDate || !endDate) {
    return false
  }

  const currentDateTz = date ? moment.tz(date, timeZone) : moment.tz(timeZone)
  const startDateTz = moment.tz(startDate, timeZone)
  const endDateTz = moment.tz(endDate, timeZone)

  return currentDateTz.isBetween(startDateTz, endDateTz, 'second', '[]')
}
